// extracted by mini-css-extract-plugin
module.exports = {"detail-header":"styles_detail-header__NjxU_","featured-carousel":"styles_featured-carousel__qv4Ba"};